import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-769ca148"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]

import { computed } from 'vue';
import { useStore } from 'vuex';
import ModalDialog from "./ModalDialog.vue";
import HtmlContent from "./HtmlContent.vue";
import CrossIcon from "../../icons/CrossIcon.vue";
import { ExtendedProductInformationLayouts } from '@/types/extendedProductInformation';

interface Props {
	modalName: string;
	content: ExtendedProductInformationLayouts;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InfoModal',
  props: {
    modalName: {},
    content: {}
  },
  setup(__props: any) {

const props = __props;
const currentModalName = computed(() => store.getters.currentModalName);
const isCurrent = computed(() => currentModalName.value === props.modalName);

const i18n = window.measurementSelectorVariables.i18n;

const store = useStore();

function closeModal() {
	store.commit('updateCurrentModalName', null);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(ModalDialog, {
      "modal-name": _ctx.modalName,
      isOpen: isCurrent.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "info-modal-close",
          type: "button",
          onClick: closeModal,
          ref: "closeButton",
          "aria-label": _unref(i18n).closeModal
        }, [
          _createVNode(CrossIcon)
        ], 8, _hoisted_1),
        _createVNode(HtmlContent, { content: _ctx.content }, null, 8, ["content"])
      ]),
      _: 1
    }, 8, ["modal-name", "isOpen"])
  ]))
}
}

})